import store from '@/store';

const subdomains = {
  dev: 'staging-api',
  // dev: 'api',
  prod: 'api'
};
const subdomain = store.getters.isDev ? subdomains.dev : subdomains.prod;
const domain = `https://${subdomain}.spheremail.co/v1/`;
const domainWithNoVersion = `https://${subdomain}.spheremail.co/`;


export default {
  domain: domain,
  storage_path: `//${subdomain}.spheremail.co`,
  auth: `${domain}authentication`,
  logout:  domainWithNoVersion + `auth/logout`,
  org_admin_locations: `${domain}organization/clients`,
  mail_items: `${domain}mail_items`,
  mail_types: `${domain}mail_types`,
  account: `${domain}account`, // .json
  account_documents: `${domain}account_documents`,
  user_plan: `${domain}account/plan`,
  reset_password: `${domain}account/reset_password`,
  validate_account: `${domain}account/validate_available`,
  validate_client: `${domain}client/validate_available`,
  notarize: `${domain}notary_packages`,
  notarize_form1583: `${domain}notary_packages/notarize_form1583`,
  countries: `${domain}countries`,
  plans: `${domain}plans`,
  cards: `${domain}credit_cards`,
  card_update: `${domain}credit_cards`,
  bank_account: `${domain}bank_account`,
  provider: `${domain}client`,
  clients: `${domain}clients`,
  client_features: `${domain}client/features`,
  color_scheme: `${domain}client/color_scheme`,
  fwd_addresses: `${domain}forward_addresses.json`,
  fwd_address: `${domain}forward_addresses`,
  sms_service: `${domain}sms_service.json`,
  user_stats: `${domain}mail_items/stats`,
  current_stats: `${domain}mail_items/current_stats`,
  joint_accounts: `${domain}joint_accounts`,
  phone_numbers: `${domain}phone_numbers`,
  phone_usages: `${domain}phone_numbers/usage_stats`,
  phone_porting: `${domain}phone_porting`,
  //outgoing_calls: `${domain}phone_numbers/outgoing_calls`,
  subscriptions: `${domain}subscriptions`,
  receptionist: `${domain}live_receptionist_plans`,
  receptionist_service: `${domain}live_receptionist_service`,
  receptionist_accounts: `${domain}additional_live_receptionist_accounts`,
  charges: `${domain}charges`,
  coupon: `${domain}coupon`,
  currency: `${domain}currencies`,
  pmb: `${domain}account/private-mailbox`,
  tickets: `${domain}tickets`,
  validate_activation_code: `${domain}enterprises/validate`,
  enterprises: `${domain}enterprises`,
  balance_adjustments: `${domain}account_balance_adjustments`,
  messaging_room: `${domain}messaging_room`,
  admin: {
    coupons: `${domain}admin/coupons`,
    color_scheme: `${domain}admin/client/color_scheme`,
    features: `${domain}admin/client/features`,
    operator_prices_lists:`${domain}admin/client/prices_lists`,
    pick_up_settings: `${domain}admin/client/mail_pick_up_settings`,
    payment_gateway: `${domain}admin/payment_gateway`,
    credit_card: `${domain}admin/client/credit_card`,
    app_provider: `${domain}admin/app_provider`,
    shipping_carriers: `${domain}admin/shipping_carriers`,
    shipping_info: `${domain}admin/shipping_info`,
    available_carriers: `${domain}admin/available_carriers`,
    webhooks: `${domain}admin/webhooks`,
    customers: `${domain}admin/customers`,
    customers_csv: `${domain}admin/customers.csv`,
    reports_mail: `${domain}admin/reports/mails`,
    reports_charges: `${domain}admin/reports/charges`,
    reports_charges_lvl3: `${domain}admin/reports/charges/level3_charges`,
    reports_charges_lvl1: `${domain}admin/reports/charges/level1_charges`,
    enable_all_month_in_charges_report: `${domain}/admin/client/unlocked_access_to_all_reports`,
    reports_revenue: `${domain}admin/reports/charges/net_revenue`,
    reports_phone: `${domain}admin/reports/charges/phone_usages`,
    reports_chargebacks_refunds: `${domain}admin/reports/charges/chargebacks_refunds`,
    reports_customers: `${domain}admin/reports/customer_quarterly_report`,
    reports_customers_csv: `${domain}admin/reports/customer_quarterly_report.csv`,
    reports_sales: `${domain}admin/reports/sales`,
    reports_yearly_revenue: `${domain}admin/reports/yearly_revenue`,
    reports_organizations: `${domain}admin/reports/organizations`,
    mail_item: `${domain}admin/mail_item`,
    publish_bulk_mail: `${domain}admin/mail_items/publish_bulk_mail`,
    remove_bulk_mail: `${domain}admin/mail_items/remove_bulk_mail`,
    mail_items: `${domain}admin/mail_items`,
    bulk_mail: `${domain}admin/mail_items/bulk_mail`,
    group_mail_items: `${domain}admin/group_mails`,
    mail_boxes: `${domain}admin/accounts/find`,
    accounts: `${domain}admin/accounts`,
    available_pmbs: `${domain}admin/free_account_numbers`,
    roles: `${domain}admin/account_roles`,
    officernd_members: `${domain}admin/officernd/members`,
    deskworks_members: `${domain}admin/deskworks/members`,
    quickbooks_members: `${domain}admin/quickbooks/members`,
    nexudus_members: `${domain}admin/nexudus/members`,
    receptionist: `${domain}admin/live_receptionist_plans`,
    notifications: `${domain}admin/notifications`,
    announcements: `${domain}admin/announcements`,
    reminders: `${domain}admin/reminders`,
    account_transfers: `${domain}admin/account_transfers`,
    accounts_import: `${domain}admin/accounts/import`,
    api_key: `${domain}admin/client/api_key`,
    tickets: `${domain}admin/tickets`,
    client_bank_account: `${domain}admin/client/bank_account`,
    prices_lists: `${domain}admin/prices_lists`,
    messaging_rooms: `${domain}admin/messaging_rooms`,
    access_api_docs: `${domain}admin/client/access_api_docs`,
    refresh_favicon: `${domain}admin/client/refresh_favicon`,
    office_rnd_config: `${domain}admin/client/officernd_configuration`,
    deskworks_config: `${domain}admin/client/deskworks_configuration`,
    deskworks_centers: `${domain}admin/deskworks/centers`,
    quickbooks_config: `${domain}admin/client/quickbooks_configuration`,
    nexudus_config: `${domain}admin/client/nexudus_configuration`,
    auth_quickbooks: `${domainWithNoVersion}auth/quickbooks/connect`,
    mass_emails: `${domain}admin/mass_emails`,
    new_location: `${domain}admin/client/new_location`,
    client: `${domain}admin/client`,
    clients: `${domain}admin/client`,
    set_is_active: `${domain}admin/client/set_is_active`,
    organizations: `${domain}admin/organizations`
  },
  links: {
    home: 'https://spheremail.co',
    about: 'https://spheremail.co/about',
    terms: 'https://spheremail.co/terms-of-service',
    policy: 'https://spheremail.co/privacy-policy',
    careers: 'https://spheremail.co/careers',
    api_documentation: '../static/api/main.html',//'/docs/api'
    new_client: 'https://spheremail.co/new-client',
    customer_help: 'http://customer-support.spheremail.co/support/home',
    admin_help: 'http://support.spheremail.co/support/home',
    csv_sample: '/customers/sample.csv',
    letter_of_authorization_sample: '/customers/letter_of_authorization.pdf'
  },
  external: {
    notary_service: 'https://www.notarycam.com/pricing/',
    google_maps: 'https://www.google.com/maps/search/',
    plaid_legal: 'https://plaid.com/legal/#consumers'
  },
  integrations: {
    officernd: {
      connect: `https://api.spheremail.co/officernd/integrations/connect`,
      configure_info: `https://api.spheremail.co/officernd/integrations/configure`,
      save_configure: `https://api.spheremail.co/officernd/integrations/configure`,
    }
  }
};
